/* @ngInject */
function AdvancedFilterController ($scope, $rootScope) {
  $scope.filterIsOpen = false
  $scope.locale = $rootScope.oUser.locale

  const api = {
    _setSelectedFiltersDisplay,
    _getSelectedFilters,
    _getFilterLabel,
    _addArrayIntoSelectedFilters
  }
  this.getApi = () => api

  const deregisterRefreshDisplay = $scope.$on('advacedFilter.refreshDisplay', (event, filters) => {
    api._setSelectedFiltersDisplay(filters)
  })

  $scope.$on('$destroy', () => {
    deregisterRefreshDisplay()
  })

  $scope.onFilterButtonClick = () => {
    $scope.filterIsOpen = !$scope.filterIsOpen
  }

  $scope.onFilterClick = (filters, hasPreFilters, filtersCount, ignoreSubmit) => {
    $scope.onFilter(filters, hasPreFilters, filtersCount, ignoreSubmit)
    api._setSelectedFiltersDisplay(filters)
  }

  $scope.onClearFiltersClick = () => {
    $scope.$broadcast('advancedSearch.clearAllFilters')
  }

  function _setSelectedFiltersDisplay (values) {
    const selectedFilters = api._getSelectedFilters(values)

    if (selectedFilters.length) {
      const firstValue = selectedFilters[0]
      const firstFilter = $scope.filters.find(filter => filter.name === firstValue.key)

      const filterLabel = api._getFilterLabel(firstFilter, firstValue)
      const filterCount = selectedFilters.length - 1

      let filterLabelWithCount = filterLabel

      if (filterCount > 0) {
        filterLabelWithCount += ` +${filterCount}`
      }

      $scope.selectedFiltersDisplay = filterLabelWithCount
    } else {
      $scope.selectedFiltersDisplay = ''
    }
  }

  function _getSelectedFilters (values) {
    const selectedFilters = []

    Object.keys(values).forEach(key => {
      const notEmpty = values[key] !== null && values[key] !== undefined && values[key] !== ''

      if (Array.isArray(values[key])) {
        if (values[key].length) {
          api._addArrayIntoSelectedFilters(selectedFilters, key, values[key])
        }
      } else if (notEmpty && (key !== 'isArchived' || (key === 'isArchived' && values[key] === true))) {
        selectedFilters.push({
          key,
          value: values[key]
        })
      }
    })

    return selectedFilters
  }

  function _getFilterLabel (filter, value) {
    let label = ''

    const selectedFilter = filter.props.options.find(option => option.value === value.value)

    if (selectedFilter) {
      label = selectedFilter.label
    }

    return label
  }

  function _addArrayIntoSelectedFilters (selectedFilters, key, values) {
    values.forEach(value => {
      selectedFilters.push({
        key,
        value
      })
    })
  }
}

export { AdvancedFilterController }
